const LANGUAGE_NAME = 'en';

const TRANSLATIONS = {
  // Component catalogue
  'storybook.buttons.title': 'Buttons',
  'storybook.buttons.description':
    'All current variants. Hover, click, or use Tab to inspect interaction states. Use the toolbar to switch theme and viewport.',
  'storybook.buttons.variants': 'Modes, colours and sizes',
  'storybook.buttons.alias-note':
    'Each pair shows enabled and disabled states. Accent and Dark currently share the same neutral appearance.',
  'storybook.buttons.color.accent': 'Accent (default)',
  'storybook.buttons.color.dark': 'Dark (same appearance)',
  'storybook.buttons.color.danger': 'Danger',
  'storybook.buttons.mode.primary': 'Primary',
  'storybook.buttons.mode.secondary': 'Secondary',
  'storybook.buttons.mode.tertiary': 'Tertiary',
  'storybook.buttons.mode.suggestion': 'Suggestion',
  'storybook.buttons.size.large': 'Regular · 34px desktop / 44px touch',
  'storybook.buttons.size.small': 'Small · 28px desktop / 44px touch',
  'storybook.buttons.icons': 'Icons and shapes',
  'storybook.buttons.other': 'Other button patterns',
  'storybook.buttons.block': 'Full width',
  'storybook.buttons.links': 'Navigation links',
  'storybook.buttons.secondary-actions': 'Secondary actions · 34px desktop / 44px touch',
  'storybook.buttons.action': 'Action',
  'storybook.buttons.add': 'Add item',
  'profile-overview.title': 'Overview',
  'profile-overview.description': 'Progress across knowledge areas',
  'profile-overview.coverage': 'Target coverage',
  'profile-overview.covered-count': '{confirmed} of {total} assigned targets confirmed',
  'profile-overview.confirmed': 'Target confirmed',
  'profile-overview.review': 'Ready for review',
  'profile-overview.below': 'Below target',
  'profile-overview.confirmed-description':
    'Knowledge areas with all assigned levels confirmed',
  'profile-overview.review-description':
    'Knowledge areas with all required exercises completed, awaiting mentor confirmation',
  'profile-overview.below-description':
    'Knowledge areas with required work still incomplete and target unconfirmed',
  'profile-overview.excluded':
    '{count} knowledge areas have no assigned target and are excluded from coverage.',
  'profile-overview.no-targets': 'No targets assigned',
  'profile-overview.unavailable': 'Data unavailable',
  'profile-overview.load-error':
    'Some profile data is unavailable. Reload the page to try again.',
  'profile-overview.filter-card': 'Filter by {name}: {count} knowledge areas',
  'profile-overview.status-filter': 'Knowledge area status',
  'profile-overview.priority-filter': 'Knowledge area priority',
  'profile-overview.all': 'All knowledge areas',
  'profile-overview.no-target': 'No target assigned',
  'profile-overview.all-priorities': 'All priorities',
  'profile-overview.clear': 'Clear filters',
  'profile-overview.results': 'Showing {shown} of {total}',
  'profile-progress.area': 'Level progress for {name}',
  'profile-progress.target': 'Assigned target: {name}',
  'profile-progress.level-status': '{name} – {status}',
  'profile-progress.confirmed': 'Confirmed',
  'profile-progress.review': 'Ready for Review',
  'profile-progress.learning': 'In Progress',
  'profile-progress.unstarted': 'Not Started',
  'profile-progress.empty': 'No Exercises',
  'profile-progress.unavailable': 'Unavailable',
  'profile-progress.no-levels': 'No levels assigned',
  'profile-progress.legend.target': 'Target',
  'profile-progress.legend.optional': 'Optional level',
  'profile-progress.legend.completion': 'Exercise completion',
  'profile-progress.legend.confirmation': 'Mentor confirmed',
  'table.action.open-details': 'Open details for {name}',
  'card.action.open-details': 'Open details',
  'dashboard.date-range.last-30-days': 'Last 30 days',
  'dashboard.date-range.last-6-months': 'Last 6 months',
  'dashboard.date-range.last-year': 'Last year',
  'dashboard.exercises-period': 'Exercises finished: {period}',
  'dashboard.time.just-now': 'just now',
  'dashboard.time.never-active': 'Never active',
  'dashboard.time.idle-days': '{days}d',
  'subscription-management.plan.starter': 'Starter',
  'subscription-management.plan.team': 'Team',

  // Dashboard and billing copy
  'dashboard.copy.date-range': 'Date range',
  'dashboard.copy.expertise-readiness': 'Expertise readiness',
  'dashboard.copy.how-ready-members-are-for-their-target':
    'How ready members are for their target positions. 100% means every required exercise is done.',
  'dashboard.copy.current-priorities': 'Current priorities',
  'dashboard.copy.priorities-across-the-currently-filtered-members-the':
    'Priorities across the currently filtered members. The dashboard date range does not affect this list.',
  'dashboard.copy.top-learners': 'Top learners',
  'dashboard.copy.members-who-completed-the-most-exercises-in':
    'Members who completed the most exercises in the selected period.',
  'dashboard.copy.stalled-members': 'Stalled members',
  'dashboard.copy.members-with-no-exercise-activity-in-the':
    'Members with no exercise activity in the selected period.',
  'dashboard.copy.recent-activity': 'Recent activity',
  'dashboard.copy.the-latest-exercises-completed-across-the-team':
    'The latest exercises completed across the team.',
  'dashboard.copy.member': 'Member',
  'dashboard.copy.exercise': 'Exercise',
  'dashboard.copy.knowledge-area': 'Knowledge Area',
  'dashboard.copy.when': 'When',
  'dashboard.copy.dashboard': 'Dashboard',
  'dashboard.copy.no-activity-found': 'No activity found.',
  'dashboard.copy.load-more': 'Load more',
  'dashboard.copy.department': 'Department',
  'dashboard.copy.position': 'Position',
  'dashboard.copy.no-members-found': 'No members found.',
  'dashboard.copy.knowledge-area-2': 'Knowledge area',
  'dashboard.copy.avg-completion': 'Avg. completion',
  'dashboard.copy.no-members-are-targeting-this-position-yet':
    'No members are targeting this position yet.',
  'dashboard.copy.priority': 'Priority',
  'dashboard.copy.no-current-priorities-found': 'No current priorities found.',
  'dashboard.copy.expertise': 'Expertise',
  'dashboard.copy.avg-readiness': 'Avg. readiness',
  'dashboard.copy.members': 'Members',
  'dashboard.copy.no-positions-with-assigned-members-found':
    'No positions with assigned members found.',
  'dashboard.copy.exercises-done': 'Exercises done',
  'dashboard.copy.completion': 'Completion',
  'dashboard.copy.last-active': 'Last active',
  'dashboard.copy.this-knowledge-area-is-not-part-of':
    'This Knowledge Area is not part of the selected position.',
  'dashboard.copy.idle': 'Idle',
  'dashboard.copy.no-recent-activity': 'No recent activity.',
  'dashboard.copy.exercises': 'Exercises',
  'dashboard.copy.no-exercise-activity-in-this-period':
    'No exercise activity in this period.',
  'dashboard.copy.no-current-priorities': 'No current priorities.',
  'dashboard.copy.no-members-with-a-target-position-assigned':
    'No members with a target position assigned yet.',
  'dashboard.copy.no-stalled-members-right-now': 'No stalled members right now.',
  'subscription-management.copy.access-frozen': 'Access frozen',
  'subscription-management.copy.payment-due': 'Payment due',
  'subscription-management.copy.cancellation-scheduled': 'Cancellation scheduled',
  'subscription-management.copy.active': 'Active',
  'subscription-management.copy.unable-to-load-billing-status':
    'Unable to load billing status.',
  'subscription-management.copy.payment-completed-waiting-for-subscription-activation':
    'Payment completed. Waiting for subscription activation...',
  'subscription-management.copy.payment-was-completed-but-subscription-activation-is':
    'Payment was completed, but subscription activation is still pending. Use Check again to check your subscription without starting another payment.',
  'subscription-management.copy.unable-to-confirm-subscription-activation':
    'Unable to confirm subscription activation.',
  'subscription-management.copy.paddle-could-not-complete-the-payment':
    'Paddle could not complete the payment.',
  'subscription-management.copy.unable-to-start-checkout': 'Unable to start checkout.',
  'subscription-management.copy.unable-to-cancel-subscription':
    'Unable to cancel subscription.',
  'subscription-management.copy.unable-to-open-billing-portal':
    'Unable to open billing portal.',
  'subscription-management.copy.loading-billing-status': 'Loading billing status...',
  'subscription-management.copy.payment-is-due-resolve-billing-by':
    'Payment is due. Resolve billing by',
  'subscription-management.copy.by-upgrading-to-team-or-reducing-active':
    ' by upgrading to Team or reducing active members to five.',
  'subscription-management.copy.to-keep-organization-access-active':
    ' to keep organization access active.',
  'subscription-management.copy.organization-access-is-frozen-resolve-billing-or':
    'Organization access is frozen. Resolve billing or reduce active members to the Starter limit to restore access.',
  'subscription-management.copy.this-organization-has-more-approved-members-than':
    'This organization has more approved members than the Starter plan allows. Upgrade to Team to keep adding members.',
  'subscription-management.copy.current-plan': 'Current plan',
  'subscription-management.copy.active-seats': 'Active seats',
  'subscription-management.copy.estimated-price': 'Estimated Team price',
  'subscription-management.copy.mo': '/mo',
  'subscription-management.copy.seats-next-period': 'Seats next period',
  'subscription-management.copy.estimated-cost-next-period': 'Estimated cost next period',
  'subscription-management.copy.ends-on': 'Ends on',
  'subscription-management.copy.renews-on': 'Renews on',
  'subscription-management.copy.billed-monthly-per-active-seat-billing-is':
    'Billed monthly per active seat. Billing is securely processed by Paddle, and your active-seat total is updated automatically for the next renewal.',
  'subscription-management.copy.starter': 'Starter',
  'subscription-management.copy.starter-users': 'Up to 5 users',
  'subscription-management.copy.starter-description':
    'For tech leads piloting structured matrices with a small pod',
  'subscription-management.copy.forever': 'forever',
  'subscription-management.copy.whats-included': "WHAT'S INCLUDED",
  'subscription-management.copy.up-to-5-team-members': 'Up to 5 team members',
  'subscription-management.copy.rolebased-skills-matrices-and-expertise-tracking':
    'Role-based skills matrices and expertise tracking',
  'subscription-management.copy.skills-readiness-and-progress-dashboard':
    'Skills readiness and progress dashboard',
  'subscription-management.copy.invite-via-secure-link-or-email':
    'Invite via secure link or email',
  'subscription-management.copy.team': 'Team',
  'subscription-management.copy.team-users': '6+ users',
  'subscription-management.copy.team-description':
    'For scaling IT companies (6 to 50+ engineers) automating career ladders',
  'subscription-management.copy.per-seat-month': 'per seat / month',
  'subscription-management.copy.everything-in-starter-plus':
    'EVERYTHING IN STARTER, PLUS',
  'subscription-management.copy.unlimited-team-members': 'Unlimited team members',
  'subscription-management.copy.priority-support': 'Priority support',
  'subscription-management.copy.opening-checkout': 'Opening checkout...',
  'subscription-management.copy.upgrade-to-team': 'Upgrade to Team',
  'subscription-management.copy.enterprise': 'Enterprise',
  'subscription-management.copy.enterprise-users': '1,000+ users',
  'subscription-management.copy.enterprise-description':
    'For tech organizations with 1000+ engineers',
  'subscription-management.copy.everything-in-team-plus': 'EVERYTHING IN TEAM, PLUS',
  'subscription-management.copy.custom': 'Custom',
  'subscription-management.copy.contact-us': 'Contact Us',
  'subscription-management.copy.dedicated-customer-success-manager':
    'Dedicated Customer Success Manager',
  'subscription-management.copy.request-custom-quote': 'Request Custom Quote',
  'subscription-management.copy.opening-portal': 'Opening portal...',
  'subscription-management.copy.manage-billing': 'Manage billing',
  'subscription-management.copy.cancel-subscription': 'Cancel subscription',
  'subscription-management.copy.cancellation-will-take-effect-at-the-end':
    'Cancellation will take effect at the end of the current billing period.',
  'subscription-management.copy.cancel': 'Cancel',
  'subscription-management.copy.cancelling': 'Cancelling...',
  'dashboard.data-error':
    'Some dashboard data could not be loaded. Metrics are unavailable until you retry.',
  'common.retry': 'Retry',
  'common.list-load-error': 'This list could not be loaded. Please try again.',
  'common.try-again': 'Try again',
  'input-copy.action': 'Copy to clipboard',
  'input-copy.copied': 'Copied to clipboard',
  'input-copy.error':
    'Could not copy. Try again or select the value and copy it manually.',
  'assignment.choices-load-error':
    '{field} choices could not be loaded. Your entries are kept. Try again before submitting.',
  'assignment.retry': 'Try loading {field} again',
  // -----------
  // AUTH FOOTER
  // -----------
  'auth-footer.terms': 'Terms of Use',
  'auth-footer.privacy': 'Privacy Policy',
  'auth-footer.cookie-settings': 'Cookie settings',
  //
  // COOKIE BANNER
  // -------------
  'cookie-banner.label': 'Cookie preferences',
  'cookie-banner.text':
    'We use optional cookies for analytics and advertising (Google Analytics, Google Ads, Hotjar) to understand how Skiloope is used and measure our ads. You can change your choice anytime in Cookie settings. Read our {privacyPolicy}.',
  'cookie-banner.privacy-policy': 'Privacy Policy',
  'cookie-banner.reject': 'Reject Cookies',
  'cookie-banner.accept': 'Accept Cookies',
  //

  // -----
  // LOGIN
  // -----
  'login.title': 'Log In',

  'login.email.label': 'Email',
  'login.email.placeholder': 'user@example.com',
  'login.password.label': 'Password',
  'login.password.placeholder': '**************',
  'login.forgot-password': 'Forgot Password?',
  'login.button': 'Log In',
  'login.not-registered-yet': 'Not registered yet?',
  'login.create-an-account': 'Create an Account',
  'login.wrong-credentials': 'Incorrect email or password',
  //

  // --------------
  // CREATE ACCOUNT
  // --------------
  'registration.title': 'Create Account',

  'registration.name.label': 'First Name',
  'registration.name.placeholder': 'John',
  'registration.name.error-required': 'Please provide your First Name',
  'registration.name.error-min': 'First Name must contain at least 2 characters',
  'registration.name.error-max': 'First Name must not contain more than 35 characters',
  'registration.name.error-no-special': 'First Name must not contain special characters',

  'registration.surname.label': 'Last Name',
  'registration.surname.placeholder': 'Doe',
  'registration.surname.error-required': 'Please provide your Last Name',
  'registration.surname.error-min': 'Last Name must contain at least 2 characters',
  'registration.surname.error-max': 'Last Name must not contain more than 35 characters',
  'registration.surname.error-no-special':
    'Last Name must not contain special characters',

  'registration.email.label': 'Email',
  'registration.email.placeholder': 'user@example.com',
  'registration.email.error': 'Please provide correct Email',
  'registration.email.error-required': 'Please provide your Email',

  'registration.password.label': 'Password',
  'registration.password.placeholder': '**************',
  'registration.password.error-min': 'Password must contain at least 8 characters',
  'registration.password.error-required': 'Please provide password',

  'registration.confirm-password.label': 'Confirm Password',
  'registration.confirm-password.placeholder': '**************',
  'registration.confirm-password.error': 'Password and it’s confirmation do not match',
  'registration.confirm-password.error-required': 'Please confirm your password',

  'registration.disclaimer': 'I agree to the {terms} and {privacy}.',
  'registration.terms.required': 'Please agree to the Terms of Use and Privacy Policy.',
  'registration.disclaimer.terms': 'Terms of Use',
  'registration.disclaimer.privacy': 'Privacy Policy',

  'registration.button': 'Create Account',
  'registration.already-registered': 'Already have an account?',
  'registration.login': 'Log In',
  //

  // ------------
  // CONFIRMATION
  // ------------
  'confirmation.title': 'Verify your Email',
  'confirmation.description':
    'Please, proceed with registration confirmation by the link which we have sent to {email}',

  'confirmation.expiring': 'The link will expire in {timer}',
  'confirmation.button': 'Resend verification link',

  'confirmation-register.title': 'Email Verified',
  'confirmation-register.description':
    'Thanks for verifying your email address, you help us keep Skiloope nice and clean!',
  'confirmation-register.button': 'Start with Log In',

  'confirmation-expired.title': 'Link Expired',
  'confirmation-expired.description':
    'It seems that the your link has expired, but you can create a new one',

  // ---------------
  // FORGOT PASSWORD
  // ---------------
  'forgot-password.title': 'Forgot Password',
  'forgot-password.button': 'Send Instructions',
  'forgot-password.no-need': 'Don’t need that?',
  'forgot-password.back-to-login': 'Back to Log In',
  'forgot-password.err-email-not-found': 'Account with this email not found',
  'forgot-password.sent':
    'Proceed password recovery by the link which we have sent to {email}',

  // ---------------
  // SET NEW PASSWORD
  // ---------------
  'reset-password.title': 'Reset Password',
  'reset-password.description': 'Please provide the new password',
  'reset-password.new-password.label': 'New Password',
  'reset-password.confirm-new-password.label': 'Confirm New Password',
  'reset-password.button': 'Save new Password',
  'reset-password.err-required': 'Please provide a new password',
  'reset-password.err-link-expired': 'Forgot password link is expired',

  'reset-password.changed.title': 'Password Changed',
  'reset-password.changed.description':
    'Your password has been changed, now you can log in with the new password',

  // ---------
  // NOT FOUND
  // ---------

  'notfound.message': 'Page not found :(',
  'notfound.action': 'Go back',
  'request-error.notice': 'The request failed. Please try again.',
  'exercise.editor.loading': 'Loading the editor…',
  'route-load.loading': 'Loading page…',
  'route-load.error': 'The page could not be loaded. Reload to try again.',
  'route-load.reload': 'Reload page',
  'server-error.went-wrong': 'Something went wrong',

  // GENERIC

  or: 'Or',

  // ---------------
  // WELCOME
  // ---------------
  'welcome.nav.title': 'Welcome',
  'welcome.title': 'Welcome, {user}!',
  'welcome.text':
    'It seems that you have not joined any organization yet. Would you like to create your own Organization Account or join an existing one?',
  'welcome.text.step1':
    'You will get an Email when organizational administrator will accept your request',

  'welcome.text.step1.button-request': 'Cancel Request',
  'welcome.create-organization': 'Create Organization',
  'welcome.join-existing': 'Join Existing',
  'welcome.step1.button-check-status': 'Check Status',

  // ---------------
  // Join organization modal step1
  // ---------------
  'join-organization.title': 'Join Organization',
  'join-organization.text':
    'Ask you organizational system administrator to provide you the Organization ID',
  'join-organization.label': 'Organization ID',
  'join-organization.placeholder': 'companyname#0000',
  'join-organization.button': 'Request Access',

  'join-organization.server-error': 'Organization with such id not found',
  'join-organization.name-error': 'Please provide correct organizationId',

  // ---------------

  // ---------------
  // Join organization check status modal
  // ---------------
  'join-organization.check-status.title': 'Still under review...',
  'join-organization.check-status.text':
    'It seems that your account is still under review. Please wait until an administrator will process your request.',
  'join-organization.check-status.button': 'Got it',
  // ---------------

  // ---------------
  // Join organization last step
  // ---------------
  'join-organization.last-step.title': 'Congratulations, {name}!',
  'join-organization.last-step.text':
    'Your join request was approved by {organization} admin. Please, provide your current expertise and position.',
  'join-organization.last-step.expertise.label': 'Expertise',
  'join-organization.last-step.position.label': 'Position',
  'join-organization.last-step.default-value.select': 'Unset',
  'join-organization.last-step.button-submit': 'Submit Expertise',
  'join-organization.last-step.button-without-expertise': 'Proceed without expertise',
  'join-organization.last-step.save-error':
    "We couldn't confirm that your choices were saved. Your selections are still here. Please try submitting again.",

  // ---------------
  // Create organization modal
  // ---------------
  'create-organization.title': 'Create Organization',
  'create-organization.name.label': 'Organization Name',
  'create-organization.name.placeholder': 'Organization Name',
  'create-organization.logo.label': 'Organization Logo',

  'create-organization.button': 'Create Organization',
  'create-organization.name-error': 'Please provide the correct organization name',
  'create-organization.logo-error': 'Please provide organization logo',
  'organization.account-update-error':
    "The action finished, but we couldn't load your updated account. Try again updates your account without repeating the action.",
  'organization.not-allowed':
    "You don't have permission to perform this action in this organization.",

  // ---------------
  // HEADER
  // ---------------
  'navigation.dashboard': 'Dashboard',
  'navigation.people': 'People',
  'navigation.expertise': 'Expertise',
  'navigation.knowledge-areas': 'Knowledge Areas',
  'dashboard.title': 'Dashboard',
  'dashboard.readiness.title': 'Expertise readiness',
  'dashboard.readiness.not-applicable': 'N/A',
  'dashboard.readiness.detail.title': 'Position Detail',
  'dashboard.readiness.skill.title': 'Knowledge Area Detail',
  'dashboard.learners.title': 'Top learners',
  'dashboard.stalled.title': 'Stalled members',
  'dashboard.activity.title': 'Recent activity',
  'dashboard.priorities.title': 'Current priorities',
  'exercise-name-cell.no-description': 'No description provided.',

  'navigation.company-members': 'People',
  'navigation.expertise-management': 'Expertise',
  'navigation.knowledge-area-management': 'Knowledge Areas',
  'header.complete-profile.button': 'Complete Profile',
  'header.main-menu.button': 'Main menu',
  'user-info.avatar.button': 'Open user menu',
  'user-menu.item.my-profile': 'My Profile',
  'user-menu.item.profile-settings': 'Settings',
  'user-menu.item.cookie-settings': 'Cookie settings',
  'user-menu.item.update-progress': 'Bulk Update',
  'user-menu.item.log-out': 'Log Out',
  'appearance.theme': 'Appearance',
  'appearance.theme.system': 'System',
  'appearance.theme.light': 'Light',
  'appearance.theme.dark': 'Dark',

  'education-progress.bulk.title': 'Update Learning Progress',
  'education-progress.bulk.description':
    'Select exercises you have completed. Checking a level or knowledge area selects all nested exercises.',
  'education-progress.bulk.loading': 'Loading progress...',
  'education-progress.bulk.empty': 'No exercises are available for update yet.',
  'education-progress.bulk.no-exercises-tooltip':
    'This item cannot be selected because it has no exercises.',
  'education-progress.bulk.save': 'Save Changes',
  'education-progress.bulk.cancel': 'Cancel',
  'education-progress.bulk.error': 'Failed to update progress. Please try again.',
  'education-progress.tree.collapse': 'Collapse {name}',
  'education-progress.tree.expand': 'Expand {name}',
  'learning-level.optional': 'Optional',

  // COMPANY MEMBERS
  // ---------------
  'company-members.welcome.title': 'Welcome to your organization, {userName}',
  'company-members.welcome.description':
    'Just send the organization ID to the company members so they will be able to request an access',
  'company-members.welcome.warning':
    'We would suggest to invite Mentors at first, so they would create the Expertises',
  'company-members.welcome.extra': 'Don’t forget to {roles}',
  'company-members.welcome.extra.roles': 'set-up user roles',
  'company-members.title': 'People',
  'company-members.invite.button': 'Invite Colleagues',
  'company-members.table.column-name': 'Name',
  'company-members.table.column-expertise': 'Expertise',
  'company-members.table.column-position': 'Position',
  'company-members.table.column-target-position': 'Target Position',
  'company-members.table.column-department': 'Department',

  'company-members.modal.title': 'Invite Colleagues',
  'company-members.modal.description.default':
    'Send the organization ID to colleagues so they can request access.',
  'company-members.modal.extra': 'Don’t forget to {roles}',

  'company-members.modal-filter.title': 'Filters',

  'company-members.modal-filter.button.apply': 'Apply Filters',
  'company-members.modal-filter.button.delete-all': 'Clear All',
  'company-members.modal-filter.title-input-checkbox': 'Expertise',

  // ---------------
  // EXPERTISE MANAGEMENT
  // ---------------
  'expertise-management.empty.title': 'Ready to upgrade your team?',
  'expertise-management.empty.description':
    'It would be really easy with our templates! Just click on “Add Expertise” to start with ready-to-go templates!',

  'expertise-management.button.add-expertise': 'Add Expertise',
  'expertise-management.list.title': 'Expertise',

  'expertise-management.modal-filter.menu': 'Industry',

  'expertise-management.list.column-name': 'Name',
  'expertise-management.list.column-industry': 'Industry',
  'expertise-management.list.column-description': 'Description',

  'expertise-management.modal.add.title': 'Add Expertise',
  'expertise-management.modal.table.column-name': 'Name',

  'expertise-management.modal.table.column-industry': 'Industry',

  'expertise-management.modal.button.fromScratch': 'Create from Scratch',
  'expertise-management.modal.button.asReference': 'Use as Reference',
  'expertise-management.modal.no-data.title': 'Nothing here yet',
  'expertise-management.modal.no-data.description':
    'Create your first Expertise to use it as a reference',

  'expertise-management.modal-settings.create.title': 'Fill Expertise Details',
  'expertise-management.modal-settings.update.title': 'Expertise Settings',
  'expertise-management.modal-settings.label.name': 'Name',
  'expertise-management.modal-settings.placeholder.name': 'Expertise name',
  'expertise-management.modal-settings.label.industry': 'Industry',
  'expertise-management.modal-settings.industry.loading': 'Loading Industries…',
  'expertise-management.modal-settings.industry.error':
    'Industries could not load. Your entries are kept. Try again to continue.',
  'expertise-management.modal-settings.industry.select':
    'Choose an available Industry to continue.',
  'expertise-management.modal-settings.error.name-max':
    'Name must be at most 50 characters',
  'expertise-management.modal-settings.label.description': 'Description',
  'expertise-management.modal-settings.placeholder.description': 'Expertise description',
  'expertise-management.modal-settings.error.description':
    'Expertise must be at most 255 characters',

  'expertise-management.modal-settings.button.update': 'Save',
  'expertise-management.modal-settings.button.delete': 'Delete Expertise',
  'expertise-management.modal-settings.delete-progress.unassign-positions':
    'Unassigning users from positions…',
  'expertise-management.modal-settings.delete-progress.unassign-expertise':
    'Unassigning users from the expertise…',
  'expertise-management.modal-settings.delete-progress.remove-knowledge-areas':
    'Removing knowledge areas from positions…',
  'expertise-management.modal-settings.delete-progress.delete-positions':
    'Deleting positions…',
  'expertise-management.modal-settings.delete-progress.delete-expertise':
    'Deleting the expertise…',

  'expertise-management.modal-position.update-position.title': 'Edit Position',
  'expertise-management.modal-position.remove-position.title': 'Delete Position',
  'expertise-management.modal-position.title-input-checkbox': 'Knowledge Area',
  'expertise-management.modal-position.duplicate-position.title': 'Duplicate Position',
  'expertise-management.modal-position.label.name': 'Position name',
  'expertise-management.modal-position.update.placeholder.name': 'Position name',

  'expertise-management.modal-position.remove-position.description':
    'Do you really want to delete {positionName} position?',

  'expertise-management.modal-position.button.update-position': 'Save',
  'expertise-management.modal-position.button.duplicate-position': 'Duplicate',
  'expertise-management.modal-position.button.remove-position': 'Delete Position',

  'expertise-management.modal-position.add-position.error': 'Position name is required',
  'expertise-management.modal-position.update-position.error':
    'Position name is required',
  'expertise-management.modal-position.duplicate-position.error':
    "Something went wrong, the position couldn't be duplicated. Please try again.",
  'expertise-management.modal-position.duplicate-position.review-required':
    'Copying could not be completed or confirmed. An unfinished copy may remain. Return to the matrix and check before trying Duplicate again.',
  'expertise-management.modal-position.duplicate-position.review-matrix':
    'Return to matrix',
  'expertise-matrix.reloading': 'Reloading the matrix…',

  'expertise-details.page-title': 'Expertise Details',
  'expertise-details.btn.info': 'Info',
  'expertise-details.btn.settings': 'Settings',
  'expertise-details.industry': 'Industry',
  'expertise-details.modal-info.title': '{valueTitle}',
  'expertise-details.modal-info.description': 'Description',
  'expertise-details.provider': 'Provider',

  'expertise-details.position.btn.add-position': 'Add Position',
  'expertise-details.position.placeholder.add-position':
    'Start typing to create a name...',
  'expertise-details.position.btn.add-knowledge-area': 'Add Knowledge Area',

  'expertise-matrix.knowledge-area-column': 'Knowledge Area ({count})',
  'expertise-matrix.add-knowledge-area.title': 'Add Knowledge Areas',
  'expertise-matrix.add-knowledge-area.description':
    'Selected knowledge areas will be added to every existing position.',
  'expertise-matrix.add-knowledge-area.no-levels.title':
    'Add levels before using these knowledge areas',
  'expertise-matrix.add-knowledge-area.no-levels.description':
    'A knowledge area needs at least one level before it can be added to an expertise.',
  'expertise-matrix.add-knowledge-area.no-levels.notice':
    '{count, plural, one {# knowledge area is hidden because it has no levels.} other {# knowledge areas are hidden because they have no levels.}}',
  'expertise-matrix.add-knowledge-area.incomplete-error':
    'Some knowledge areas could not be added with a required level. Close this window and use “Set first level” in the matrix to finish the setup.',

  'expertise-matrix.empty.title': 'Build your expertise matrix',
  'expertise-matrix.empty.positions':
    'Create at least one position before adding knowledge areas.',
  'expertise-matrix.empty.knowledge-areas':
    'Add knowledge areas to define the shared skill structure.',
  'expertise-matrix.remove-row.title': 'Remove from all positions',
  'expertise-matrix.remove-row.description':
    'Remove {knowledgeArea} from every position where it is currently assigned?',
  'expertise-matrix.remove.action': 'Remove',
  'expertise-matrix.cancel': 'Cancel',
  'expertise-matrix.normalize.title': 'Normalize expertise matrix',
  'expertise-matrix.normalize.description':
    'This expertise uses different knowledge-area orders across positions. The matrix requires one shared order.',
  'expertise-matrix.normalize.details':
    'Normalize the order to continue, or leave without changing the expertise.',
  'expertise-matrix.normalize.action': 'Normalize',
  'expertise-matrix.normalize.leave': 'Cancel and leave',
  'expertise-matrix.partial-error':
    'Some changes could not be completed. The matrix was refreshed with the current server data.',
  'expertise-matrix.operation-error':
    'The change could not be confirmed. Some parts may have been saved. Check the refreshed matrix before trying again.',
  'expertise-matrix.reload-error':
    'The matrix could not be loaded. Try again only reloads saved data; it does not repeat your changes.',
  'expertise-matrix.choices-error':
    'Knowledge Area choices could not be loaded. Your selections are kept. Try again before adding.',
  'expertise-matrix.no-levels': 'No levels available',
  'expertise-matrix.no-required-level': 'No required level',
  'expertise-matrix.set-first-level': 'Set first level',
  'expertise-matrix.row.aria-reorder': 'Reorder {name}',
  'expertise-matrix.row.aria-open': 'Open {name}',
  'expertise-matrix.row.aria-remove-row': 'Remove {name} from all positions',
  'expertise-matrix.cell.aria-add': 'Add knowledge area to position',
  'expertise-matrix.slider.aria-label': 'Required level',
  'expertise-matrix.cell.aria-remove': 'Remove knowledge area from position',
  'expertise-matrix.position.aria-actions': 'Actions for {name}',
  'expertise-matrix.scroll-to-add-position.aria': 'Scroll to add position',
  // ---------------
  // Profile
  // ---------------

  'general-data-profile.nav.title': 'Settings',

  // Profile Settings - General Data
  'general-data.label.firstName': 'First Name',
  'general-data.label.lastName': 'Last Name',
  'general-data.label.email': 'Email',

  'avatar-upload.button': 'Change photo',
  'settings.profile.title': 'Profile',
  'settings.profile.description':
    'Your name and photo are visible to the people in your organization.',
  'settings.appearance.title': 'Appearance',
  'settings.appearance.description': 'Choose how Skiloope looks on this device.',
  'settings.password.title': 'Password',
  'settings.password.description': 'We will email you a link to set a new password.',
  'settings.danger.title': 'Danger zone',
  'settings.danger.description':
    'Permanently delete your profile and all related data, including your expertise and its progress. This cannot be undone.',

  'general-data.button.save-changes': 'Save Changes',
  'general-data.button.delete-organization': 'Delete Profile',
  'general-data.button.modal-delete.title': 'Delete Profile',
  'general-data.modal-delete.button': 'Permanently Delete Profile',
  'general-data.modal-delete.description':
    'I really want to permanently delete my profile and all related data, including personal expertise and it’s progress',

  // Profile Settings - General Data Buttons
  'general-data.change-password': 'Change Password',
  'general-data.change-password.description':
    'We have sent the instructions to' +
    ' {email}, please check your email and proceed with further steps.',

  // Profile KnowledgeAre expertise

  'profile.knowledge-are-details-title': '{valueTitle}',
  'profile.knowledge-area-details.required-levels-title':
    'Target required proficiency levels',
  'profile.knowledge-area-details.optional-levels-title': 'Optional proficiency levels',
  'profile.knowledge-area-details.completion.awaiting-confirmation':
    'Completed, awaiting mentor confirmation',
  'profile.knowledge-area-details.completion.confirmed': 'Completed and Confirmed',
  'profile.knowledge-area-details.completion.confirmed-details':
    'Completed and Confirmed ({details})',
  'profile.knowledge-are-details.modal.no-data.title': 'Nothing here yet',
  'profile.knowledge-are-details-no-data-title': 'It seems that there are no exercises.',

  // I really want to permanently delete my profile and all related data,
  // including personal expertise and it’s progress
  // ---------------
  // MANAGE ORGANIZATION
  // ---------------
  'manage-organization.title': 'Manage Organization',

  // Manage Organization - General Information
  'general-information.nav.title': 'General Information',
  'general-information.label.logo': 'Organization Logo',
  'general-information.label.name': 'Organization Name',
  'general-information.placeholder.name': 'Organization Name',
  'general-information.label.id': 'Organization ID',
  'general-information.button.save': 'Save Changes',
  'general-information.button.delete': 'Delete Organization',
  'general-information.danger.description':
    'Delete knowledge areas and expertises and cancel the subscription before deleting this organization. Members will become guests. This cannot be undone.',
  'general-information.modal-delete.title': 'Delete Organization',
  'general-information.modal-delete.button': 'Permanently Delete Organization',
  'general-information.modal-delete.description':
    'I want to permanently delete the {organizationName} organization. All members, including me, will become guests and leave this organization.',

  // Manage Organization - User Management
  'user-management.nav.title': 'User Management',

  'user-management.modal.remove-user.title': 'Remove user',
  'user-management.modal.remove-user.text':
    'I really want to remove {userName} and all the related data from {organizationName} Organization',
  'user-management.modal.remove-user.button': 'Remove user',
  'user-management.modal.remove-user.leads-blocked':
    'This user leads {names}. Reassign their leadership from Organization Structure before removing them.',

  'user-management.modal.edit-user.title': 'User Details',
  'user-management.modal.edit-user.name.label': 'Name',
  'user-management.modal.edit-user.email.label': 'Email',
  'user-management.modal.edit-user.expertise.label': 'Expertise',
  'user-management.modal.edit-user.position.label': 'Position',
  'user-management.modal.edit-user.target-position.label': 'Target Position',
  'user-management.modal.edit-user.role.label': 'Role',
  'user-management.modal.edit-user.department.label': 'Department',
  'user-management.modal.edit-user.unit.label': 'Unit',
  'user-management.modal.edit-user.button': 'Save',
  'user-management.filter.button': 'Filter',

  'user-management.modal.resolve-leads.title': 'Reassign leadership',
  'user-management.modal.resolve-leads.description':
    'Changing this user’s role will remove them as lead of the following Departments and Units. Select a replacement lead for each, or leave it unassigned.',
  'user-management.modal.resolve-leads.cancel': 'Cancel',
  'user-management.modal.resolve-leads.confirm': 'Confirm and Save',

  'user-management.modal-filter.title': 'Filters',
  'user-management.modal-tab.role': 'Role',
  'user-management.new-requests':
    '{count, plural, one {# New Request} other {# New Requests}}',
  'user-management.modal-tab.expertise': 'Expertise',
  'user-management.modal-tab.department': 'Department',
  'user-management.modal-tab.unit': 'Unit',
  'member-filter.no-unit': 'No unit',

  // Manage Organization - Department Management (aka "Organization Structure")
  'department-management.no-data.title': 'Nothing here yet',
  'department-management.no-data-description':
    'Create your first department to easily access to your team members',
  'department-management.no-data.button': 'Create Department',
  'department-management.nav.title': 'Organization Structure',
  'department-management.btn': 'Create Department',

  'department-management.card.lead-label': 'Lead',

  'department-management.modal.create-department.title': 'Create Department',
  'department-management.modal.create-department.name.label': 'Department Name',
  'department-management.modal.create-department.name.placeholder': 'Example Department',
  'department-management.modal.create-department.lead.label': 'Lead',
  'department-management.modal.create-department.button': 'Create Department',
  'department-management.modal.create-department.error': 'Please provide department name',

  'department-management.modal.edit-department.title': 'Edit Department',
  'department-management.modal.edit-department.name.label': 'Department Name',
  'department-management.modal.edit-department.name.placeholder': 'Example Department',
  'department-management.modal.edit-department.lead.label': 'Lead',
  'department-management.modal.edit-department.button': 'Save',

  'department-management.modal.remove-department.title': 'Delete Department',
  'department-management.modal.remove-department.text':
    'I really want to remove {departmentName} department',
  'department-management.modal.remove-department.units-warning':
    'This will also delete {count, plural, one {# unit} other {# units}} in this department: {unitNames}.',
  'department-management.modal.remove-department.button': 'Remove Department',

  // Manage Organization - Unit Management (nested inside Organization Structure)
  'unit-management.add-unit.button': 'Add Unit',
  'unit-management.no-units': 'No units in this department yet',
  'unit-management.table.column-name': 'Unit',
  'unit-management.table.column-lead': 'Lead',
  'unit-management.modal.department.placeholder': 'Select department',

  'unit-management.modal.create-unit.title': 'Create Unit',
  'unit-management.modal.create-unit.name.label': 'Unit Name',
  'unit-management.modal.create-unit.name.placeholder': 'Example Unit',
  'unit-management.modal.create-unit.department.label': 'Department',
  'unit-management.modal.create-unit.lead.label': 'Lead',
  'unit-management.modal.create-unit.button': 'Create Unit',
  'unit-management.modal.create-unit.name-error': 'Please enter a unit name',

  'unit-management.modal.edit-unit.title': 'Edit Unit',
  'unit-management.modal.edit-unit.name.label': 'Unit Name',
  'unit-management.modal.edit-unit.name.placeholder': 'Example Unit',
  'unit-management.modal.edit-unit.department.label': 'Department',
  'unit-management.modal.edit-unit.lead.label': 'Lead',
  'unit-management.modal.edit-unit.button': 'Save',
  'unit-management.modal.edit-unit.name-error': 'Please enter a unit name',

  'unit-management.modal.remove-unit.title': 'Delete Unit',
  'unit-management.modal.remove-unit.text': 'I really want to remove {unitName} unit',
  'unit-management.modal.remove-unit.button': 'Remove Unit',

  // Lead picker (Department/Unit leads, role-change resolutions)
  'lead-picker.unassigned': 'Unassigned',

  // Manage Organization - Subscription Management
  'subscription-management.nav.title': 'Subscription Management',

  'subscription-management.cancel.title': 'Cancel subscription',

  // roles

  // global
  'data-not-found.table.title': 'Nothing found',
  'data-not-found.table.description':
    'There are no results by the given search condition',

  // ---------------
  // NOTIFICATIONS
  // ---------------

  // ---------------
  // JOIN REQUESTS
  // ---------------
  'join-requests.modal.title': '{valueTitle} Join Requests',
  'join-requests.modal.warning':
    'New users will be added with Mentee roles, don’t forget to {roles} for Mentors',
  'join-requests.modal.warning-roles': 'set up roles',

  'join-requests.modal.table.column-name': 'Name',
  'join-requests.modal.table.column-email': 'Email',

  'join-requests.modal.button.reject': 'Reject Selected',
  'join-requests.modal.button.approve': 'Approve Selected',
  'join-requests.modal.seat-limit.title': 'No available seats',
  'join-requests.modal.seat-limit.text':
    'There are no available seats. Upgrade your subscription to allow more members to join.',
  'join-requests.modal.seat-limit.upgrade': 'Upgrade subscription',
  'join-requests.modal.seat-limit.cancel': 'Cancel',
  'join-requests.modal.seat-limit.mentor.title': 'No available seats',
  'join-requests.modal.seat-limit.mentor.text':
    'There are no available seats. Please ask your organization admin to upgrade the subscription before approving more members.',
  'join-requests.modal.request-error.text':
    'We could not process the selected requests. Please refresh and try again.',
  'join-requests.modal.refresh-pending.text':
    'Updating the latest join-request information. Please wait.',
  'subscription-management.check-again': 'Check again',
  'removal.saved-refresh-error':
    'The item was removed, but its date or updated information could not be refreshed. Try again only reloads information; it does not repeat removal or the date update.',
  'template-copy.choices-error':
    'Templates could not be loaded. Your selection is kept. Try again before copying.',
  'template-copy.review-required':
    'Copying could not be completed or confirmed. An unfinished copy may remain. Review the list before trying another copy.',
  'template-copy.review-list': 'Review list',
  'join-requests.modal.refresh-error.text':
    'The latest requests or billing information could not be loaded. Try again only reloads information; it does not repeat approval or rejection.',
  'join-requests.modal.subscription-cancellation.title':
    'Subscription cancellation scheduled',
  'join-requests.modal.subscription-cancellation.text':
    'Your Team subscription is scheduled to end. Reactivate it through Manage billing before approving more members.',
  'join-requests.modal.subscription-cancellation.manage': 'Manage billing',
  'join-requests.modal.billing-state.title': 'Billing status unavailable',
  'join-requests.modal.billing-state.text':
    'We refreshed the join requests, but could not determine the current billing state. Open Subscription Management to review it before trying again.',
  'join-requests.modal.billing-state.manage': 'Open subscription management',
  'join-requests.modal.payment-due.title': 'Payment due',
  'join-requests.modal.payment-due.text':
    'Payment is due for the organization. New members cannot be approved until billing is resolved.',
  'join-requests.modal.subTitle': 'Your team is ready!',
  'join-requests.modal.text':
    'We’ll let you know when someone requests to join your organization.',

  // ---------------
  // KNOWLEDGE AREA
  // ---------------
  'knowledge-area.empty.title': 'Seems to be empty...',
  'knowledge-area.empty.paragraph-1':
    'There is no Knowledge Areas, you can get back to Expertises and set-up them, in this case Knowledge Areas of your Expertises will appear here.',
  'knowledge-area.empty.paragraph-2':
    'Or you can Add Knowledge Areas here, so you will be able to use them within your Expertises in future.',
  'knowledge-area.button-add': 'Add Knowledge Area',

  'knowledge-area.modal.add.title': 'Add Knowledge Area',

  'knowledge-area.modal.table.column-name': 'Name',
  'knowledge-area.modal.table.column-category': 'Category',

  'knowledge-area.modal.button.fromScratch': 'Create from Scratch',
  'knowledge-area.modal.button.asReference': 'Use as Reference',
  'knowledge-area.modal.no-data.title': 'Nothing here yet',
  'knowledge-area.modal.no-data.description':
    'Create your first Knowledge Area to use it as a reference',

  'knowledge-area.list.title': 'Knowledge Areas',
  'knowledge-area.list.button': 'Add Knowledge Area',
  'knowledge-area.list.table.column-name': 'Name',
  'knowledge-area.list.table.column-category': 'Category',
  'knowledge-area.list.table.column-description': 'Description',

  'knowledge-area.details.title': 'Knowledge Area Details',
  'knowledge-area.details.btn.info': 'Info',
  'knowledge-area.details.settings.button': 'Settings',

  'knowledge-area.details.details-item.category': 'Category',

  'knowledge-area.details.details-item.no-content.title': 'Nothing here yet...',
  'knowledge-area.details.details-item.no-content.text':
    'Add first level to Knowledge Area, so you will be able to fill it with the exercises',

  'knowledge-area.from-scratch.title': 'Knowledge Area - From Scratch',
  'knowledge-area.modal.settings.title': 'Knowledge Area Settings',
  'knowledge-area.modal.settings.name.label': 'Name',
  'knowledge-area.modal.settings.name.placeholder': 'Name',
  'knowledge-area.modal.settings.name.error': 'Please provide name of knowledge area',
  'knowledge-area.modal.settings.category.label': 'Category',
  'knowledge-area.modal.settings.description.label': 'Description',
  'knowledge-area.modal.settings.description.placeholder': 'Description...',
  'knowledge-area.modal.settings.description.error':
    'Description must be at most 255 characters',
  'knowledge-area.modal.settings.created-by': 'Created By',
  'knowledge-area.modal.settings.created-on': 'Created On',
  'knowledge-area.modal.settings.last-edited-by': 'Last Edited By',
  'knowledge-area.modal.settings.last-edited-on': 'Last Edited On',
  'knowledge-area.modal.settings.create.button': 'Create',
  'knowledge-area.modal.settings.save.button': 'Save',
  'knowledge-area.modal.settings.delete.button': 'Delete Knowledge Area',
  'knowledge-area.delete.title': 'Delete Knowledge Area?',
  'knowledge-area.delete.description': 'Delete “{name}”? This action cannot be undone.',
  'knowledge-area.delete.in-use':
    'This Knowledge Area is still in use. Check the position matrices in Expertise and remove its assignments before trying again.',
  'knowledge-area.delete.failed':
    'Deletion could not be confirmed. The Knowledge Area may still be assigned to a position. Check its assignments in Expertise and reload the list before trying again.',

  'knowledge-area.level-management.title': 'Levels',
  'knowledge-area.level-management.button': 'Add Level',

  'knowledge-area.exercise-management.title': '{name} Exercises',
  'knowledge-area.exercise-management.button': 'Add Exercise',

  'knowledge-area.no-exercises.title': 'Add Exercises',
  'knowledge-area.no-exercises.description':
    'Now you can add exercises so your team will be able to get knowledges faster, using valid sources',
  'knowledge-area.no-exercises.button': 'Add Exercise',

  'knowledge-area.level-details.modal.title': 'Level Details',
  'knowledge-area.level-details.modal.name.label': 'Name',
  'knowledge-area.level-details.modal.name.placeholder': 'Level name',
  'knowledge-area.level-details.modal.error': 'Level name is required',
  'knowledge-area.level-details.modal.button': 'Save',

  'knowledge-area.level-add.placeholder': 'Start typing to create a name...',
  'knowledge-area.level-delete.modal.title': 'Delete Level',
  'knowledge-area.level-delete.modal.description':
    'Do you really want to delete {levelName} level?',
  'knowledge-area.level-delete.modal.button.delete': 'Delete Level',

  'knowledge-area.exercise.modal.title': 'Exercise Details',
  'knowledge-area.exercise.modal.name.label': 'Name',
  'knowledge-area.exercise.modal.name.placeholder': 'Exercise name',
  'knowledge-area.exercise.modal.name.error': 'Exercise name is required',
  'knowledge-area.exercise.modal.type.label': 'Type',
  'knowledge-area.exercise.modal.description.label': 'Description',
  'knowledge-area.exercise.modal.description.error': 'Exercise description is required',
  'knowledge-area.exercise.modal.description.error-length':
    'Description must be at most 2000 characters',
  'knowledge-area.exercise.modal.attachments.label': 'Attachments',
  'knowledge-area.exercise.modal.attachments.hint':
    'Drag and drop files here, or click to browse. Up to 100 MB per file.',
  'attachments.status.saved': 'Saved',
  'attachments.status.uploading': 'Uploading',
  'attachments.status.scanning': 'Scanning',
  'attachments.status.ready': 'Ready',
  'attachments.status.error': 'Upload failed',
  'attachments.status.rejected': 'Rejected',
  'attachments.reason.file-too-large': 'Over the 100 MB limit',
  'attachments.reason.file-empty': 'This file is empty',
  'attachments.reason.duplicate-file': 'Already added',
  'attachments.download': 'Download attachment',
  'attachments.preview': 'Preview attachment',
  'attachments.preview.title': 'Preview: {valueTitle}',
  'attachments.preview.loading': 'Preparing the attachment preview…',
  'attachments.preview.loading-viewer': 'Loading the file viewer…',
  'attachments.preview.error':
    'This attachment could not be previewed. You can retry or download it instead.',
  'attachments.preview.retry': 'Retry preview',
  'attachments.preview.close': 'Close',
  'attachments.preview.download': 'Download',
  'attachments.generic-name': 'Attachment',

  'knowledge-area.exercise.modal.button.save': 'Save',
  'knowledge-area.exercise.modal.error.generic':
    'Unable to save the exercise. Please try again.',

  'knowledge-area.exercise-delete.modal.title': 'Delete Exercise',
  'knowledge-area.exercise-delete.modal.description':
    'Do you really want to delete {exerciseName} exercise?',
  'knowledge-area.exercise-delete.modal.button.delete': 'Delete Exercise',

  // ---------------

  // KNOWLEDGE AREA - POSITION
  'knowledge-area-in-position.modal.button.createNewKnowledgeArea':
    'Create New Knowledge Area',
  'knowledge-area-in-position.modal.button.addSelected': 'Add Selected',

  'knowledge-area-in-position.modal.no-data.title': 'Nothing here yet',
  'knowledge-area-in-position.modal.no-more-data.title': 'Nothing more to add',
  'knowledge-area-in-position.modal.no-data.description':
    'Create your first Knowledge Area to add it to your Expertise',
  'knowledge-area-in-position.modal.no-more-data.description':
    'You have added all Knowledge Areas that exist in your organization',
  // ---------------

  // ---------------
  // KNOWLEDGE AREA - USER PROFILE

  'user-profile.knowledge-area.exercise.mark-done': 'Mark as Done',
  'user-profile.knowledge-area.exercise.mark-undone': 'Undo',
  'user-profile.knowledge-area.exercise.add-proof': 'Add proof',
  'user-profile.knowledge-area.exercise.edit-proof': 'Edit proof',
  // ---------------

  // ---------------
  // EXERCISE PROOF
  'exercise-proof.modal.title': 'Proof of Completion',
  'submitted-proofs.button':
    'View {count, plural, one {# proof} other {# proofs}} for {name}',
  'submitted-proofs.title': 'Submitted proofs',
  'submitted-proofs.description': '{name} · {area}',
  'submitted-proofs.loading': 'Loading submitted proofs…',
  'submitted-proofs.error': 'Submitted proofs could not be loaded.',
  'submitted-proofs.retry': 'Retry',
  'submitted-proofs.empty': 'No submitted proofs are available for this knowledge area.',
  'exercise-proof.modal.description.label': 'Description',
  'exercise-proof.modal.description.placeholder': 'Describe what you did...',
  'exercise-proof.modal.description.error': 'Description is required',
  'exercise-proof.modal.description.error-length':
    'Description must be at most 2500 characters',
  'exercise-proof.modal.attachments.label': 'Attachment',
  'exercise-proof.modal.attachments.hint':
    'Drag and drop a file here, or click to browse. Up to 100 MB.',
  'exercise-proof.modal.button.save': 'Save',
  'exercise-proof.modal.button.delete': 'Delete proof',
  'exercise-proof.modal.error.generic': 'Unable to save the proof. Please try again.',
  'exercise-proof.delete.modal.title': 'Delete Proof',
  'exercise-proof.delete.modal.description': 'Do you really want to delete this proof?',
  'exercise-proof.delete.modal.button.delete': 'Delete Proof',
  // ---------------

  // ---------------
  // EDUCATION PRIORITY
  'education-priority.level.trivial': 'Trivial',
  'education-priority.level.minor': 'Minor',
  'education-priority.level.major': 'Major',
  'education-priority.level.critical': 'Critical',
  'education-priority.level.unset': 'No Priority',

  'education-priority.picker.title': 'Select priority',
  'education-priority.picker.due-date-title': 'Select due date',
  'education-priority.picker.no-due-date': 'No due date',
  'education-priority.picker.back': 'Back',
  'education-priority.picker.previous-month': 'Previous month',
  'education-priority.picker.next-month': 'Next month',
  // ---------------

  // ---------------
  // KNOWLEDGE AREA LEVEL CONFIRMATION
  'knowledge-area-level-confirmation.label.unset': 'Not Confirmed',
  'knowledge-area-level-confirmation.picker.title': 'Select confirmed level',
  'knowledge-area-level-confirmation.action.clear': 'Clear confirmation',
  'knowledge-area-level-confirmation.error.request-failed':
    'Unable to save the confirmation. Please try again.',
  // ---------------

  // ---------------
  // USER PROFILE

  'user-profile.knowledge-area-details.nav.title': 'Profile Knowledge Area Details',
  'user-profile.welcome.title': 'Expertise not yet assigned',
  'user-profile.welcome.text.description':
    'Ask your company admin to assign you to your expertise',
  'user-profile.tour-welcome.title': 'Welcome to your profile!',
  'user-profile.tour-welcome.description':
    'Take a quick tour to see how to track your progress, priorities, and skill levels.',
  'user-profile.tour-welcome.button.begin': 'Begin Tour',
  'user-profile.tour-welcome.button.skip': 'Skip',
  'user-profile.tour.subheader.description':
    'This is where you’ll find your spot in the org: your expertise, current and target position, department, and unit.',
  'user-profile.tour.summary.description':
    'See your target coverage and select a summary card to filter your knowledge areas. Switch to Activity to explore your recorded updates.',
  'user-profile.tour.detalization.description':
    'Filter your knowledge areas by status, priority, or name. Each progress square represents a level; hover or focus it for details. The divider marks your assigned target.',
  'user-profile.tour.bulk-update.description':
    'Already have hands-on experience with some of these? Use Bulk Update to set your levels for several skills at once, instead of one by one.',
  'user-profile.tour.first-row.description':
    'Click a skill’s name to see the exercises waiting for you there.',
  'user-profile.info_position': 'Current Position',
  'user-profile.info_target-position': 'Target Position',
  'user-profile.info_department': 'Department',
  'user-profile.info_unit': 'Unit',
  'user-profile.info_expertise': 'Expertise',

  'user-profile.your-focus.title': 'Next Up',
  'user-profile.your-focus.empty.title': 'No learning priorities yet',
  'user-profile.your-focus.empty.mentor': 'your mentor',
  'user-profile.your-focus.empty.description':
    'Ask {mentorName} to set your learning priorities so you know what to focus on next.',
  'user-profile.your-focus.empty.no-exercises.title': 'No upcoming exercises',
  'user-profile.your-focus.empty.no-exercises.description':
    'Your current priorities have no required exercises. Ask {mentorName} to review your learning plan.',
  'user-profile.your-focus.open-exercise': 'Open {exerciseName}',
  'user-profile.your-focus.level-name': '{levelName} level',
  'user-profile.summary.title': 'Summary',
  'user-profile.activity-details.title': 'Activity Details',
  'user-profile.detalization.title': 'Progress Detalization',
  'user-profile.progress-detalization.table.order': '#',
  'user-profile.progress-detalization.table.knowledge-area': 'Knowledge Area',

  'user-profile.progress-detalization.table.progress': 'Progress',
  'user-profile.progress-detalization.table.priority': 'Priority',
  'user-profile.progress-detalization.table.confirmed-level': 'Confirmed Level',

  'user-profile.progress-detalization.empty.title': 'Seems to be empty',
  'user-profile.progress-detalization.empty.text':
    'Ask your mentor to fulfil your expertise to start your educational journey',
  // ---------------

  // ------------------
  // SHARED COMPONENTS
  // ------------------
  'action-menu.btn.more-options': 'More options',
  'action-menu.btn.close': 'Close actions menu',
  'action-menu.item.edit': 'Edit',
  'action-menu.item.duplicate': 'Duplicate',
  'action-menu.item.remove': 'Remove',
  'tabs.btn.more': 'More',
  'search.input.placeholder': 'Search...',
  'search.input.label': 'Search',
  'search.button.open': 'Open search',
  'search.button.clear': 'Clear search',
  'common.close': 'Close',
  'common.dialog': 'Dialog',
  'common.cancel': 'Cancel',
  'common.more-information': 'More information',
  'education-priority.modal.error.request-failed':
    'Could not update the priority. Please try again.',
  'common.submit': 'Submit',
  'attachments.remove': 'Remove attachment',
  'exercise.btn.options': 'Exercise options',
  'pagination.btn.next': 'Next page',
  'pagination.btn.prev': 'Previous page',
  'pagination.label': 'Pagination',
  'pagination.page': 'Page {page}',
  'pagination.summary': 'Page {current} of {total}',
  'active-filters.btn.remove': 'Remove filter',

  'filters.button': 'Filters',
  'filters.add': 'Add Filter',
  'filters.by': 'Filter by…',
  'filters.all': 'All {category}',
  'filters.search-values': 'Search {category} filters',
  'filters.search-placeholder': 'Filter to…',
  'filters.no-values': 'No matching values',
  'filters.remove-value': 'Remove {category} filter: {value}',
  'filters.category': 'Category',
  'filters.industry': 'Industry',
  'common.back': 'Back',
  // ---------------
};

export { LANGUAGE_NAME, TRANSLATIONS };
